import React, { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import { logger } from "@/common/utils/logger";

const GlobalErrorBoundary = ({ children }) => {
  const [globalError, setGlobalError] = useState(null);

  useEffect(() => {
    // Catch uncaught JS errors
    const handleWindowError = (event) => {
      setGlobalError(
        event.error || new Error(event.message || "Unknown Error"),
      );
      logger.error("Global error caught:", event.error);
    };

    // Catch unhandled promise rejections
    const handleRejection = (event) => {
      setGlobalError(event.reason || new Error("Unhandled Promise Rejection"));
      logger.error("Unhandled promise rejection:", event.reason);
    };

    window.addEventListener("error", handleWindowError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleWindowError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  if (globalError) {
    return (
      <ErrorFallback
        error={globalError}
        resetErrorBoundary={() => setGlobalError(null)}
      />
    );
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => console.log("React error boundary reset")}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
